import { Component, RefObject, createRef } from 'react';
import Select from 'react-select';
import './SelectList.scss';
import DropdownIndicator from './DropdownIndicator';
import ClearIndicator from './ClearIndicator';
import { Option } from '../../core/models/components.model';
import { styleObject } from './SelectCustomStyling';
import StateManagedSelect from 'react-select/dist/declarations/src/stateManager';

interface SelectListProps {
  options: Option[];
  selectedOptions: Option[];
  config?: { isMulti?: boolean; isClearable?: boolean, autoFocus?: boolean, isDisabled?: boolean };
  placeholder?: string;
  onChange: (option: Option[]) => void;
}

interface SelectListState {
  selectedOptions: Option[],
  options: Option[],
  isLoading: boolean,
}

class SelectList extends Component<SelectListProps, SelectListState> {
  selectRef: RefObject<StateManagedSelect>;

  constructor(props: SelectListProps) {
    super(props);
    this.selectRef = createRef();
    const { options, selectedOptions } = this.props;
    this.state = {
      selectedOptions,
      options: props.options?.filter(opt => !opt?.isDisabled),
      isLoading: options ? false : true,
    }
  }

  componentDidUpdate(prevProps: SelectListProps) {
    const { options, selectedOptions } = this.props;
    if (prevProps.options !== options) {
      this.setState({
        options: options?.filter(opt => !opt?.isDisabled),
        isLoading: options ? false : true,
      }); 
    }
    if (prevProps.selectedOptions !== selectedOptions) {
      this.setState({ selectedOptions });
    }
  }

  handleChange = (selectedOptions: any) => {
    if (selectedOptions) {
      this.setState(
        { selectedOptions: selectedOptions as Option[] },
        () => this.props.onChange(selectedOptions as Option[])
      );
    } else {
      this.setState({ selectedOptions: [] });
      this.props.onChange([])
    }
  };

  
  render() {
    const { config } = this.props;
    const { options, selectedOptions, isLoading } = this.state;

    return (
      <div className="select-list-container">
        <div className="select-list-row-container">
          <div className={`select-list`}>
            <Select
              value={selectedOptions}
              onChange={this.handleChange}
              components={{ DropdownIndicator, ClearIndicator }}
              placeholder={this.props.placeholder || "Selecione..."}
              options={options}
              isLoading={isLoading}
              isDisabled={isLoading}
              styles={styleObject}
              {...config}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default SelectList;
